<template>
    <b-modal ref="avatarModal" hide-footer centered @close="btnSfx" :title="$t('login.avatar_popup_title')">
        <div v-if="page == 'list'" class="avatarModal w-100">
            <p class="text-center">{{ $t('login.avatar_popup_description') }}</p>
            <input @change="readFile" type="file" ref="imageInput" class="d-none" accept="image/*"/>
            <div class="avatarModalList text-center row ml-0 mr-0">
                <div class="col-4 p-0 mb-3"><a @click.prevent="$refs.imageInput.click();btnSfx();" href="#" class="btnUpload"><span><i class="fas fa-camera"></i> {{ $t('login.avatar_popup_btn_upload') }}</span></a></div>
                <div v-for="a in avatars" :key="a.name" class="col-4 p-0 mb-3"><a @click.prevent="avatar = a;btnSfx();" href="#" :class="avatar != undefined && avatar.name == a.name ? 'selected' : ''"><img :src="a.url"></a></div>
            </div>
            <div class="text-center">
                <b-button variant="primary" size="lg" @click="saveAvatar();btnSfx();" class="pl-4 pr-4">{{ $t('login.avatar_popup_btn_save') }}</b-button>
            </div>
        </div>
        <div v-if="page == 'crop'" class="w-100">
            <div id="avatarCroppie" class=""></div>
            <div class="text-center d-flex flex-column">
                <b-button variant="primary" size="lg" @click="crop();btnSfx();" class="pl-4 pr-4 m-auto">{{ $t('login.avatar_popup_btn_save') }}</b-button>
                <button @click="cancelCrop();btnSfx();" class="btn pl-4 pr-4 text-primary m-auto">{{ $t('base.btn_cancel') }}</button>
            </div>
        </div>
    </b-modal>
</template>
<script>
import Vue from 'vue'
import api from '../api'
import Croppie from 'croppie'

const AvatarPopup = Vue.component('avatar-popup', {
    data() {
        return {
            page: 'list',
            avatars: [],
            cropper: undefined,
            avatar: undefined,
            avatarUrl: undefined,
        }
    },
    methods:{
        
        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        async show() {
            this.$refs.avatarModal.show();
            this.page = 'list';
            this.avatar = undefined;

            let loader = document.getElementById('loader');
            loader.classList.add("show");

            try {
                let r = await api.getCommonAvatars();
                this.avatars = r.data;
            } catch(error){
                api.baseErrorHendler(error);
            }

            loader.classList.remove("show");
        },
        hide() {
            this.$refs.avatarModal.hide();
        },  

        readFile(input) {
            const $this = this;
            if (input.target.files && input.target.files[0]) {
                let reader = new FileReader();
                this.page = 'crop';
                this.avatar = undefined;
                reader.onload = function (e) {
                    $this.setCrop(e.target.result);
                }
                reader.readAsDataURL(input.target.files[0]);
            }
        },

        setCrop(rawImg){
            
            this.cropper = new Croppie(document.getElementById('avatarCroppie'), {
                showZoomer: false,
                enableExif: true,
                viewport: {
                    width: 220,
                    height: 220,
                    type: 'circle'
                },
                boundary: {
                    width: 220,
                    height: 220
                }
            });

            this.cropper.bind({
                url: rawImg,
            });
        },

        cancelCrop(){
            this.cropper.destroy();
            this.page = 'list';
        },

        crop(){
            const $this = this;
            this.cropper.result({
                type: 'blob',
                format: 'jpeg',
                circle: false,
                size: { width: 512, height: 512 }
            }).then(function (resp) { 

                let loader = document.getElementById('loader');
                loader.classList.add("show"); 

                api.uploadAvatar(resp).then((data) => {
                    $this.$store.dispatch('auth/setUser', data.data);
                    $this.$emit('updateAvatar', data.data.avatarUrl);
                    loader.classList.remove("show");
                    $this.hide();
                }).catch(error => {
                    api.baseErrorHendler(error);
                    loader.classList.remove("show");
                })
            });
        },

        saveAvatar(){
            if(this.avatar == undefined)
                return this.hide();

            const $this = this;
            let loader = document.getElementById('loader');
            loader.classList.add("show"); 

            api.setAvatar(this.avatar.name).then(data => {
                $this.$store.dispatch('auth/setUser', data.data);
                $this.$emit('updateAvatar', data.data.avatarUrl);
                loader.classList.remove("show");
                $this.hide();
            }).catch(error => {
                api.baseErrorHendler(error);
                loader.classList.remove("show");
            });

        },
    }
})

export default AvatarPopup
</script>